import { visuallyHidden } from '@mui/utils';
import { useTranslation } from 'react-i18next';

interface ChartDataTableProps {
  title: string;
  labels: string[];
  values: number[];
  /** Formats a value the way the chart's tooltip does; defaults to the locale number format. */
  formatValue?: (value: number, index: number) => string;
}

/**
 * The data behind a chart as a visually hidden table, so the chart has a text alternative
 * (WCAG 1.1.1). Rendered next to the chart, not instead of it.
 */
export const ChartDataTable = ({ title, labels, values, formatValue }: ChartDataTableProps) => {
  const { t, i18n } = useTranslation();
  const format = formatValue ?? ((value: number) => value.toLocaleString(i18n.language));

  return (
    <table style={visuallyHidden}>
      <caption>{title}</caption>
      <thead>
        <tr>
          <th scope="col">{t('common.labels.name')}</th>
          <th scope="col">{t('common.labels.value')}</th>
        </tr>
      </thead>
      <tbody>
        {labels.map((label, index) => (
          <tr key={index}>
            <th scope="row">{label}</th>
            <td>{format(values[index] ?? 0, index)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
